import { render, staticRenderFns } from "./CardRed.vue?vue&type=template&id=88074e94&scoped=true"
import script from "./CardRed.vue?vue&type=script&lang=ts"
export * from "./CardRed.vue?vue&type=script&lang=ts"
import style0 from "./CardRed.vue?vue&type=style&index=0&id=88074e94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88074e94",
  null
  
)

export default component.exports